import { ApiResponse } from './types';
import { apiClient } from './core/apiClient';
import { IAuditFilters, IAuditLogItem } from '../types/interfaces/IAudit';

export async function getAuditLogs(
  filters: IAuditFilters
): Promise<ApiResponse<IAuditLogItem[]>> {
  return apiClient.get<IAuditLogItem[]>('/audit-logs', {
    institutionId: filters.institutionId,
    entityName: filters.entityName,
    action: filters.action,
    from: filters.from,
    to: filters.to,
  });
}
